export const Home = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15">
    <g fill="none" fillRule="evenodd">
      <g fill="#2396FD" fillRule="nonzero">
        <g>
          <path
            d="M32.7 97.06l-3.6-3.26-3.6 3.26v6.04h7.2v-6.04zm1.526 1.058v6.58H23.915v-6.58l-.817.78-1.017-1.066 6.99-6.672 6.99 6.672-1.018 1.066-.817-.78z"
            transform="translate(-22 -90) translate(0 -.5)"
          />
        </g>
      </g>
    </g>
  </svg>
);
